import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsStartedPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_STARTED;
    id: string;
    attributes: {
      aggregate: {
        projects_started: InsightMetric;
      };
    };
  };
}

export const parseProjectsStartedPayload = (
  payload: BaseInsightPayload
): ProjectsStartedPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_STARTED,
    data.attributes,
    false,
    true,
    ['projects_started']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { projects_started: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_STARTED,
      id: data.id,
      attributes: {
        aggregate: {
          projects_started: typedAttributes.aggregate.projects_started,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
